import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { selectedProductSkus } from 'yoda-site-components/lib/selectors/ProductOptionsSelector';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './ProductModelNumber.css';

const cx = classNames.bind(styles);

class ProductModelNumber extends Component {
    static defaultProps = {
        selectedProductLot: [],
        className: '',
    };

    static propTypes = {
        selectedProductLot: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        className: PropTypes.string,
    };

    rendermoduleId(modelNumber) {
        let renderHTML;
        /* istanbul ignore else */
        if (modelNumber !== '' && modelNumber !== undefined) {
            renderHTML = <div className={dt(['mt-1'])}>Model #{modelNumber}</div>;
        }
        return renderHTML;
    }

    render() {
        const { selectedProductLot, className } = this.props;
        return (
            <div
                className={`${className} ${dt(['text-sm', 'font-open-sans', 'text-gray-60'])}`}
                data-automation-id="productModelNumber"
                aria-label="productModelNumber"
            >
                {selectedProductLot &&
                selectedProductLot.length &&
                selectedProductLot[0].modelNumber
                    ? this.rendermoduleId(selectedProductLot[0].modelNumber)
                    : null}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    selectedProductLot: selectedProductSkus(false)(state),
});

export default connect(mapStateToProps)(ProductModelNumber);
